import { render, staticRenderFns } from "./Processors.vue?vue&type=template&id=16260ba0"
import script from "./Processors.vue?vue&type=script&lang=js"
export * from "./Processors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports